module.exports = __webpack_public_path__ + "static/img/part1-dis.849c22b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part1-dis.png
// module id = SEvo
// module chunks = 1